import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calculator, ArrowRight } from "react-bootstrap-icons";
import { BaseWidget } from "../common/BaseWidget";
import "../../styles/DistributionQuoteWidget.css";

export function DistributionQuoteWidget() {
  const [contractNumber, setContractNumber] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmed = contractNumber.trim();
    if (!trimmed) return;
    navigate(
      `/contracts/${encodeURIComponent(trimmed)}/disbursement-quote-request`,
    );
  };

  return (
    <BaseWidget className="cp-dq">
      <div className="cp-dq__header">
        <div className="cp-dq__icon" aria-hidden="true">
          <Calculator />
        </div>
        <div>
          <h3 className="cp-dq__title">Distribution Quote</h3>
          <p className="cp-dq__subtitle">Get a quote for any contract</p>
        </div>
      </div>

      <div className="cp-dq__label">Contract Number</div>
      <form className="cp-dq__form" onSubmit={handleSubmit}>
        <input
          type="text"
          className="cp-dq__input"
          placeholder="e.g. CP-50081"
          value={contractNumber}
          onChange={(event) => setContractNumber(event.target.value)}
          aria-label="Contract number"
        />
        <button type="submit" className="cp-dq__button">
          Get Quote
          <ArrowRight aria-hidden="true" />
        </button>
      </form>
    </BaseWidget>
  );
}
